import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }

import { cn } from '@/lib/utils';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import DataTableSortButton from '@/components/datatable/DataTableSortButton.vue';
    import type { Column, Table } from '@tanstack/vue-table';
    import HoverInfo from '@/components/HoverInfo.vue';

    interface DataTableColumnHeaderProps {
        column: Column<any, any>;
        table?: Table<any>;
        title: string;
        info?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableColumnHeader',
  props: {
    column: {},
    table: {},
    title: {},
    info: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const hasSelectedRows = computed(() => {
        return props.table && props.table.getFilteredSelectedRowModel().flatRows.length > 0;
    });

    const title = computed(() => {
        return t(props.title);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('flex items-center gap-1', _ctx.$attrs.class ?? ''))
  }, [
    (_ctx.column.getCanSort())
      ? (_openBlock(), _createBlock(DataTableSortButton, {
          key: 0,
          column: _ctx.column,
          title: title.value,
          "table-has-selected-rows": hasSelectedRows.value
        }, null, 8, ["column", "title", "table-has-selected-rows"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(title.value), 1)),
    (_ctx.info)
      ? (_openBlock(), _createBlock(HoverInfo, {
          key: 2,
          content: _unref(t)(_ctx.info)
        }, null, 8, ["content"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})